<span class="alert-message" [ngClass]="isSuccess ? 'alert-success' : 'alert-error'">{{
  message
}}</span>
